let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gbv01")).then(() => parcelRequire('4VGMo'));